import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Carousel from "../../atoms/carousel";
import Icon from "../../atoms/icon";
import { get } from "lodash";
import styles from "./styles.m.css";
import DigitalEbookStoryCard from "../../atoms/digital-ebook-story-card";
import DigitalEbookStoryCardTop from "../../atoms/digital-ebook-story-card-top";

const SliderEbookCard = ({
  collection,
  numberOfCardsInViewDesktop = 2.9,
  numberOfCardsInViewTablet = 3,
  numberOfCardsInViewMobile = 1.3,
  accentColor
}) => {
  const desktopGap = 10;
  const mobileGap = 0;

  const slides = collection.items.map(({ story }) => (
    <DigitalEbookStoryCard
      key={story.id}
      story={story}
      className={styles.card}
      onClickEbookOffer={() => {
        if (userType !== "P" && userType !== "T" && userType !== "R") {
          setShowEbookOfferPopup(true);
          setIsVisible(true);
        }
      }}
    />
  ));

  const topCard =
    collection && collection.items[0] ? (
      <DigitalEbookStoryCardTop
        story={collection.items[0].story}
        className={styles["top-card"]}
        bigimage={true}
        pFrom={"slider-ebook-card"}
      />
    ) : null;
  const topStory = collection.items[0].story;

  const description = get(topStory, ["cards", 0, "story-elements", 0, "text"], "E book").replace(/<[^>]*>/g, "");

  const [expanded, setExpanded] = React.useState(false);
  const [showEbookOfferPopup, setShowEbookOfferPopup] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  const [isClosedManually, setIsClosedManually] = React.useState(false);
  const lastScrollY = useRef(0);
  const [userType, setUserType] = React.useState("F");

  useEffect(() => {
    if (global && global.userPromise) {
      global.userPromise.catch(() => ({})).then(user => {
        if (user && user.userType) {
          setUserType(user.userType);
        }
      });
    }
  }, []);

  useEffect(
    () => {
      const handleScroll = () => {
        if (isClosedManually || userType === "P" || userType === "T" || userType === "R") return;
        const currentScrollY = window.scrollY;
        const scrollThreshold = 0.4 * (global.window ? window.innerHeight : 400);

        if (currentScrollY > scrollThreshold) {
          setShowEbookOfferPopup(true);
          setIsVisible(true);
        } else if (currentScrollY < scrollThreshold * 0.8) {
          setIsVisible(false);
        }
        lastScrollY.current = currentScrollY;
      };

      if (global.window) {
        window.addEventListener("scroll", handleScroll, { passive: true });
      }
      return () => {
        if (global.window) {
          window.removeEventListener("scroll", handleScroll);
        }
      };
    },
    [isClosedManually, userType]
  );
  const maxLength = 1000;
  const shortDescription = description.length > maxLength ? description.slice(0, maxLength) + "..." : description;

  const domainName = global && global.location && global.location.origin;
  return (
    <div className={styles.base}>
      <div className={`container ${styles["carousel-wrapper"]}`}>
        <div className={styles["collection-header"]}>
          <div>
            <h2 className={styles["collection-title"]}>{topStory.headline}</h2>
            <div className={styles["collection-description"]}>
              {expanded ? description : shortDescription}
              {description.length > maxLength && (
                <button className={styles["readmore-button"]} onClick={() => setExpanded(!expanded)}>
                  {expanded ? "Read Less" : "Read More"}
                  <Icon type={expanded ? "angle-up" : "angle-down"} className={styles["readmore-icon"]} />
                </button>
              )}
            </div>
          </div>
          {topCard}
        </div>
        <div className={styles["slider-wrapper"]}>
          {collection && collection.name && <h2 className={styles["collection-title"]}>{collection.name}</h2>}
          <Carousel
            className={styles["carousel"]}
            options={{
              type: "carousel",
              perView: numberOfCardsInViewDesktop,
              gap: desktopGap,
              rewind: false,
              peek: {
                before: 0,
                after: 244
              },
              breakpoints: {
                991: {
                  perView: numberOfCardsInViewTablet,
                  gap: desktopGap,
                  peek: {
                    before: desktopGap,
                    after: 244
                  }
                },
                767: {
                  perView: numberOfCardsInViewMobile,
                  gap: mobileGap,
                  peek: {
                    before: mobileGap,
                    after: 144
                  }
                }
              }
            }}
            renderCenterLeftControls={({ previousSlide, currentSlide }) =>
              currentSlide > 0 ? (
                <button
                  aria-label="previous slide"
                  role="button"
                  onClick={previousSlide}
                  className={`${styles["slider-nav-button"]}`}
                >
                  <Icon type="angle-left" className={styles.icon} />
                </button>
              ) : null
            }
            renderCenterRightControls={({ nextSlide }) => (
              <button
                aria-label="next slide"
                role="button"
                onClick={nextSlide}
                className={`${styles["slider-nav-button"]}`}
              >
                <Icon type="angle-right" className={styles.icon} />
              </button>
            )}
            childClass={styles["glide_li"]}
          >
            {slides}
          </Carousel>
        </div>
      </div>
      {showEbookOfferPopup && (
        <div
          className={`${styles["ebook-offer-popup-overlay"]} ${isVisible ? styles["is-visible"] : styles["is-hidden"]}`}
        >
          <div className={styles["ebook-offer-popup-content"]}>
            <button
              className={styles["ebook-offer-popup-close"]}
              onClick={() => {
                setIsVisible(false);
                setIsClosedManually(true);
                setTimeout(() => setShowEbookOfferPopup(false), 600); // Wait for exit animation
              }}
            >
              <Icon type="close" />
            </button>
            <div className={styles["ebook-offer-popup-body"]}>
              <div className={styles["ebook-offer-popup-text-wrapper"]}>
                <div className={styles["ebook-offer-popup-wrap"]}>
                  <div className={styles["ebook-offer-popup-description"]}>
                    <p>அன்பு வாசகரே,</p>
                    <p>
                      இதுபோன்ற ₹10,000 மதிப்பிலான விகடன் டிஜிட்டல் புத்தகங்கள் மற்றும் விகடனின் தரம்மிக்க படைப்புகளைத்
                      தங்குதடையின்றி வாசிக்க, இன்றே விகடன் டிஜிட்டல் சந்தாதாரர் ஆகுங்கள்.
                    </p>
                  </div>
                  <div className={styles["ebook-offer-popup-text-inner"]}>
                    <div className={styles["ebook-offer-popup-text-content"]}>
                      <h2>LIMITED TIME OFFER</h2>
                      <h3>விகடன் டிஜிட்டல் சந்தா + டிஜிட்டல் புக்ஸ் + விகடன் ப்ளே</h3>
                    </div>
                    <div className={styles["ebook-offer-popup-text-logo"]}>
                      <img src="https://images.assettype.com/vikatan/2026-03-21/kmlm13n9/vikatan-icon.png" />
                    </div>
                    <div className={styles["ebook-offer-popup-pricing"]}>
                      <div className={styles["offer-duration"]}>1 Year</div>
                      <div className={styles["offer-price"]}>₹1749</div>
                      <div className={styles["original-price"]}>₹899</div>
                    </div>
                  </div>
                </div>
                <div className={styles["ebook-offer-popup-cta"]}>
                  <a href={`${domainName}/user/login`} className={styles["login-btn"]}>
                    Already a subscriber? Log in
                  </a>
                  <a href="/subscription" className={styles["subscribe-btn"]}>
                    GET OFFER
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

SliderEbookCard.propTypes = {
  accentColor: PropTypes.string,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default SliderEbookCard;
